import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import '@toca/arco-design-web-vue/dist/arco.css';
import { store } from './store/store';
import { authorize } from './login';
import VueCookies from 'vue-cookies';
import 'virtual:svg-icons-register';
import SvgIcon from './components/SvgIcon.vue';
import { Message } from '@toca/arco-design-web-vue';
import {
    setSaviorConfigure,
    updateSaviorData,
    saviorEventUUID
} from '@/utils/savior';
import config from '../package.json';
import Tci18nVue3, { useI18n } from 'tci18n-vue3';
import { reportFirstScreen } from '@/utils/reportFirstScreen';
const { lang } = useI18n();
import { getBrowser } from './utils/browser';
// import './assets/arco_custom.css';
import Vconsole from 'vconsole';
import * as Sentry from "@sentry/vue";
import { version } from '../package.json';

declare global {
    interface Window {
        tocaSentryStartTimeStamp: number;
        tocaSentryService: {
            tocaEditorLoadStartTransaction: {
                end: (timestamp?: number) => void,
                getSpanJSON: () => { data: Record<string, any> }
            };
        },
    }
}

function _createApp() {
    handleSourceFrom();
    handleVisible();
    console.time('time1111111111111App');
    const app = createApp(App);
    app.component('svg-icon', SvgIcon); // 注册svg全局组件
    app.use(Tci18nVue3, {
        locale: __tci18n_locale__,
        langs: __tci18n_langs__
    });
    app.use(router);
    app.use(Message);
    // app.use(ArcoVue);
    app.use(store);
    app.use(VueCookies);

    if (import.meta.env.MODE !== 'production') {
        const vConsoel = new Vconsole();
    }

    configi18n(lang);

    app.mount('#app');
    (window as any)['app'] = app;
    let tocaEdit = config.dependencies['@toca/toca-edit'];
    (window as any)['config'] = config;
    setSaviorConfigure();
    updateSaviorData({
        eventtype: 'info',
        category: 'firstScreen',
        label: '首屏加载浏览器性能对象上报',
        eventid: 'firstScreen_performance',
        value: {
            ...performance.timing,
            id: saviorEventUUID
        }
    });
    console.log('tocaEdit', tocaEdit);
    // Sentry
    try {
        const environment = import.meta.env.VITE_APP_STATIC_NODE_ENV || 'development';

        Sentry.init({
            app,
            dsn: 'https://d3ea50cc826b9616053f561c1424a8ed@rum.17u.cn/225',
            tracesSampleRate: 1.0,
            release: version,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
            environment: environment,
            maxBreadcrumbs: 10,
            integrations: [
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                    maxReplayDuration: 10 * 60 * 1000,
                }),
                Sentry.browserTracingIntegration(),
                Sentry.captureConsoleIntegration({ levels: ['error'] }),
            ],
            // beforeSend仅对error有效
            beforeSend(event, hint) {
                if (event.request && event.request.url) {
                    try {
                        const urlObj = new URL(event.request.url);
                        const fid = urlObj.searchParams.get('fid');
                        event.tags = event.tags || {};
                        event.tags[`custom_tag_fid`] = fid;
                    } catch (e) {
                        // 忽略解析错误
                    }
                }
                return event;
            }
        });

        const userInfo = store.state.userModule;
        Sentry.setUser(userInfo);
        if (userInfo.userId) Sentry.setTag("custom_tag_userId", userInfo.userId);
        const editorVersionMatch = String(tocaEdit).match(/toca-edit-(\d+\.\d+\.\d+)\.tgz/);
        Sentry.setTag("custom_tag_editorVersion", editorVersionMatch ? editorVersionMatch[1] : 'unknown');

        if (window.tocaSentryStartTimeStamp && window.tocaSentryStartTimeStamp > 0) {
            // sentry的事物只会生效一次
            window.tocaSentryService.tocaEditorLoadStartTransaction = Sentry.startInactiveSpan({
                name: "知识库首屏加载时间",
                startTimestamp: window.tocaSentryStartTimeStamp / 1000,
                forceTransaction: true,
                attributes: {
                    href: window.location.href,
                }
            });
        }

    } catch (error) {
        console.error('init sentry error', error);
    }
}

function configi18n(language: string) {
    store.dispatch('kbModule/setWikiI18n', language);
}

function handleSourceFrom() {
    //处理souce来源，屏蔽部分功能
    let localUrl = window.location.href;
    if (localUrl.length > 0) {
        const searchParams = new URL(localUrl).searchParams;
        let source = searchParams.get('source');
        if (source && source.length > 0) {
            store.dispatch('kbModule/setSourceFrom', source);
            //隐藏知识库目录
            const isInToca = getBrowser().isInTocaApp;
            if (isInToca === true && source === 'home') {
                store.dispatch('kbTreeNodeModule/setKBDirExpand', false);
            }
        }
    }
}

function handleVisible() {
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
            // 页面隐藏
            console.log('111111111111111111111页面隐藏');
            reportFirstScreen();
        } else {
            // 页面显示
            console.log('111111111111111111111页面显示');
        }
    });
}

/// 写入测试cookie
if (import.meta.env.VITE_APP_STATIC_NODE_ENV === 'dev') {
    const cookies: any = VueCookies;

    //
    cookies.set('spaceId', '0583d');
    cookies.set('userId', '154263553403101184');
    cookies.set('token', '40e847cfde2a422a8a5e43f7fae07896');
    cookies.set('deviceId', 'a538ae858ffcfbff5570f97f8565ca23');
    cookies.set('memberId', '213672292987805696');
}

const localUrl = window.location.href;

let params = new URL(location.href).searchParams;
if (params.get('showtype')) {
    store.dispatch('kbModule/setShowType', params.get('showtype'));
}

if (params.get('showtype') == 'sdk') {
    //等待sdk传入初始化参数
    window.addEventListener('message', e => {
        console.log('子页面子页面e子页面e子页面e子页面ee', e);
        let data = e.data;
        if (data.type === 'userInfo') {
            let userInfo = data.data;
            store.dispatch('userModule/setBaseUserInfo', {
                userId: userInfo.userId,
                spaceId: userInfo.spaceId,
                deviceId: userInfo.deviceId,
                token: userInfo.token
            });

            authorize({
                redirectUrl: localUrl,
                agentId: 'uk7bj.toca.tiptab.backend' // qa agentId
            }).then(res => {
                console.log('res', res);
                _createApp();
            });
        }
    });
    window.parent.postMessage(
        {
            type: 'ready',
            data: {}
        },
        '*'
    );
} else {
    const userId = (VueCookies as any).get('userId');
    const spaceId = (VueCookies as any).get('spaceId');
    const deviceId = (VueCookies as any).get('deviceId');
    const token = (VueCookies as any).get('token');

    //从cookie中获取用户数据设置到store中
    store.dispatch('userModule/setBaseUserInfo', {
        userId,
        spaceId,
        deviceId,
        token
    });
    const isWpsExport = localUrl.includes("/wiki/exportwps") || params.get("isWps") === "true";
    if (isWpsExport) {
        _createApp(); // 如果是导出wps，直接创建app不需要登陆
    } else {
        authorize({
            redirectUrl: localUrl,
            agentId: 'uk7bj.toca.tiptab.backend' // qa agentId
        }).then(res => {
            console.log('res', res);
            _createApp();
        });
    }
}
